/**
 * @description Get a random array index.
 * @param array - generic array
 *
 * @example
 * const arr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];
 * let randomElement = arr[getRandomArrayIndex(arr)];
 */
export const getRandomArrayIndex = <Type>(array: Type[]) => Math.floor(Math.random() * array.length);
